import { withStyles } from '@material-ui/core';
import React from 'react';
import CustomTextField from '../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField';

const styles = (theme) => ({
  container: {
    maxWidth: '140px'
  },
  input: {
    padding: 4,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: 'initial'
  },
  marginNormal: { margin: 0 },
  startAdornment: {
    marginRight: 4
  }
});

const StandardTextField = ({
  classes,
  value,
  handleUpdate,
  placeholder,
  startAdornment,
  mask,
  ...otherProps
}) => {
  return (
    <div className={classes.container}>
      <CustomTextField
        mainClassProps={{ marginNormal: classes.marginNormal }}
        mask={mask}
        value={value}
        variant="standard"
        autoComplete="off"
        placeholder={placeholder}
        handleChange={handleUpdate}
        startAdornment={startAdornment}
        InputPropsClasses={{
          input: classes.input
        }}
        startAdornmentClasses={{
          positionStart: classes.startAdornment
        }}
        {...otherProps}
      />
    </div>
  );
};

export default withStyles(styles)(StandardTextField);
